import Event from './event';
import Home from './home';
import News from './news';
import Page from './page';
import PropTypes from 'prop-types';
import React from 'react';
import Show from './show';
import Venue from './venue';

function Template({ data, type }) { // eslint-disable-line require-jsdoc
    switch (type) {
        case 'event':
            return <Event data={data} />;
        case 'home':
            return <Home data={data} />;
        case 'news':
            return <News data={data} />;
        case 'show':
            return <Show data={data} />;
        case 'venue':
            return <Venue data={data} />;
        default:
            return <Page data={data} />;
    }
}

Template.propTypes = {
    data: PropTypes.object,
    type: PropTypes.string.isRequired
};

export default Template;
